import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-update-role-modal",
  templateUrl: "./update-role-modal.component.html",
  styleUrls: ["./update-role-modal.component.css"],
})
export class UpdateRoleModalComponent implements OnInit {
  @Input() userDetails: any;
  @Input() roleList: any;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  private ls = new SecureLS({ encodingType: "aes" });
  addRoleForm: FormGroup;
  departmentList = [];
  studentBatchList = [];
  studentSectionList = [];
  backendValidationErrors: null;
  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public globalService: GlobalService
  ) {}
  get addRoleFormCtrl() {
    return this.addRoleForm.controls;
  }
  async ngOnInit() {
    this.addRoleForm = this.fb.group({
      id: [""],
      role: [""],
      profDepartment: [""],
      department: [""],
      studentDepartment: [""],
      studentBatch: [""],
      studentSection: [""],
    });
    this.getDropdownData();
  }

  async getDropdownData() {
    this.spinner.show();
    const baseFilter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
    };
    const sDepFilter = { ...baseFilter, role_id: "5" };
    const depFilter = { ...baseFilter, role_id: "4" };
    this.addRoleForm.reset();
    this.addRoleForm.controls["role"].patchValue(
      this.roleList
        .filter((e1) =>
          this.userDetails["userByRole"]?.some((e2) => e1.id === e2.id)
        )
        ?.map((e) => e.id)
    );
    const department = await this.globalService.get(
      "department/list/dropdown",
      depFilter,
      true
    );
    this.departmentList = department["content"];

    const studentBatch = await this.globalService.get(
      "batch/list/dropdown",
      sDepFilter,
      true
    );
    this.studentBatchList = studentBatch["content"];

    this.updateFormdDateFromUserDetails(false);
    this.spinner.hide();
  }

  onRoleChange() {
    if (this.addRoleFormCtrl.role.value.length) {
      this.updateFormdDateFromUserDetails(false);
    } else {
      this.addRoleForm.controls["profDepartment"].patchValue(null);
      this.addRoleForm.controls["department"].patchValue(null);
      this.addRoleForm.controls["studentDepartment"].patchValue(null);
      this.addRoleForm.controls["studentBatch"].patchValue(null);
      this.addRoleForm.controls["studentSection"].patchValue(null);
    }
    this.backendValidationErrors = null;
  }

  modalClose(): void {
    this.modalService.dismissAll();
  }

  async addingRole() {
    if (!this.addRoleForm.dirty) {
      Swal.fire("Warning!", "No changes made", "warning");
      return false;
    }
    const valArr = this.addRoleFormCtrl.role.value
      ? this.addRoleFormCtrl.role.value
      : [];
    let addOrDeleteTitle;
    let addOrDeleteMsg;
    if (this.userDetails.userByRole.length - 1 > valArr.length) {
      addOrDeleteTitle = "Delete";
      addOrDeleteMsg = "remove";
    } else if (this.userDetails.userByRole.length - 1 == valArr.length) {
      addOrDeleteTitle = "Update";
      addOrDeleteMsg = "change";
    } else {
      addOrDeleteTitle = "Create";
      addOrDeleteMsg = "add";
    }
    Swal.fire({
      title: `${addOrDeleteTitle} ?`,
      text: `Are you sure want to ${addOrDeleteMsg} the role?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let depId = "";
        if (
          this.addRoleFormCtrl.role.value.length == 2 &&
          this.addRoleFormCtrl.role.value?.includes(4) &&
          this.addRoleFormCtrl.role.value?.includes(5)
        ) {
          depId = this.addRoleFormCtrl.department.value;
        } else if (
          (this.addRoleFormCtrl.role.value.length == 1 &&
            this.addRoleFormCtrl.role.value?.includes(4)) ||
          (this.addRoleFormCtrl.role.value.length == 2 &&
            this.addRoleFormCtrl.role.value?.includes(4) &&
            this.addRoleFormCtrl.role.value?.includes(3))
        ) {
          depId = this.addRoleFormCtrl.profDepartment.value;
        } else if (
          (this.addRoleFormCtrl.role.value.length == 1 &&
            this.addRoleFormCtrl.role.value?.includes(5)) ||
          (this.addRoleFormCtrl.role.value.length == 2 &&
            this.addRoleFormCtrl.role.value?.includes(5) &&
            this.addRoleFormCtrl.role.value?.includes(3))
        ) {
          depId = this.addRoleFormCtrl.studentDepartment.value;
        }
        const requestPayload = {
          user_id: this.ls.get("createdBy"),
          mapping_user_id: this.userDetails?.id,
          vendor_id: this.ls.get("vendor_id"),
          mapping_roles: [...valArr, this.userDetails?.role_id],
          department_id: (depId != '') ? depId : this.userDetails['department_id'],
          batch_id: this.addRoleFormCtrl.studentBatch.value,
          section: this.addRoleFormCtrl.studentSection.value,
        };

        const addingRoleData = await this.globalService.create(
          "commonUser/create-role-mapping ",
          requestPayload
        );
        if (addingRoleData["status"] === 200) {
          this.backendValidationErrors = null;
          Swal.fire("Success!", addingRoleData["message"], "success");
          this.notifyParent.emit("success");
          this.modalClose();
          this.spinner.hide();
        } else if (addingRoleData["status"] === 422) {
          this.backendValidationErrors = addingRoleData["error"]["content"];
          this.spinner.hide();
        } else {
          this.modalClose();
          this.spinner.hide();
          this.backendValidationErrors = null;
        }
      } else {
        this.updateFormdDateFromUserDetails(true);
      }
    });
  }
  updateFormdDateFromUserDetails(isRoleUpdate) {
    if (isRoleUpdate) {
      this.addRoleForm.controls["role"].patchValue(
        this.roleList
          .filter((e1) =>
            this.userDetails["userByRole"]?.some((e2) => e1.id === e2.id)
          )
          ?.map((e) => e.id)
      );
    }
    this.addRoleForm.controls["profDepartment"].patchValue(
      this.userDetails?.department_id
    );
    this.addRoleForm.controls["department"].patchValue(
      this.userDetails?.department_id
    );
    this.addRoleForm.controls["studentDepartment"].patchValue(
      this.userDetails?.department_id
    );
    this.addRoleForm.controls["studentBatch"].patchValue(
      this.userDetails?.batch_id
    );
    this.addRoleForm.controls["studentSection"].patchValue(
      this.userDetails?.section
    );
  }
}
